import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";

const initial = {
  name: "",
  lastName: "",
  email: "",
  password: "",
  phone: "",
  country: "",
};

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState(initial);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [acceptedData, setAcceptedData] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!acceptedTerms || !acceptedData) {
      setError("Debes aceptar ambas condiciones para continuar.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await register({
        ...form,
        termsConsent: true,
        dataConsent: true,
        consentAt: new Date().toISOString(),
      });
      navigate("/dashboard", {
        state: {
          presetSymbol: searchParams.get("symbol") || undefined,
          presetChain: searchParams.get("chain") || undefined,
          presetAmount: searchParams.get("amount") || undefined,
        },
      });
    } catch (err) {
      const msg = err.response?.data?.message;
      setError(msg === "email_in_use" ? "Ese correo ya está registrado." : "No se pudo crear la cuenta.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="auth-screen">
        <form className="auth-card" onSubmit={submit}>
          <h1 className="auth-title">Crear cuenta</h1>
          <p className="auth-subtitle">
            Tu identidad se verifica de forma segura más adelante, antes de tu primera compra — no hace falta
            completarla ahora.
          </p>

          <div className="field-row">
            <div className="field">
              <label>Nombre</label>
              <input value={form.name} onChange={update("name")} required />
            </div>
            <div className="field">
              <label>Apellido</label>
              <input value={form.lastName} onChange={update("lastName")} required />
            </div>
          </div>

          <div className="field">
            <label>Correo</label>
            <input type="email" value={form.email} onChange={update("email")} required />
          </div>

          <div className="field">
            <label>Contraseña</label>
            <input type="password" value={form.password} onChange={update("password")} required />
          </div>

          {/* <div className="field-row">
            <div className="field">
              <label>Teléfono (opcional)</label>
              <input value={form.phone} onChange={update("phone")} placeholder="+58..." />
            </div>
            <div className="field">
              <label>País (opcional)</label>
              <input value={form.country} onChange={update("country")} placeholder="Venezuela" />
            </div>
          </div> */}

          <div className="consent-row">
            <label className="consent-label">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              <span className="consent-text">
                Haciendo click aquí, aceptas nuestros{" "}
                <a href="/terminos-y-condiciones" target="_blank" rel="noreferrer" className="consent-link">
                  Términos y Condiciones
                </a>{" "}
                y{" "}
                <a href="/proteccion-de-datos" target="_blank" rel="noreferrer" className="consent-link">
                  Política general en materia de Protección de Datos
                </a>{" "}
                de Walletven y nos autorizas a contactarte por E-mail, SMS y Whatsapp.
              </span>
            </label>
          </div>

          <div className="consent-row">
            <label className="consent-label my-1">
              <input
                type="checkbox"
                checked={acceptedData}
                onChange={(e) => setAcceptedData(e.target.checked)}
              />
              <span className="consent-text my-1">
                En cumplimiento de lo dispuesto en el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica
                3/2018, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD),
                JMS Intermedia SLU, informa que sus datos personales serán ser cedidos a Fintech Payments
                SL, con la finalidad de gestión administrativa y prestación de servicios.
              </span>
            </label>
          </div>

          {error && <p className="error-text">{error}</p>}

          <button className="btn btn-primary btn-block" disabled={busy || !acceptedTerms || !acceptedData}>
            {busy ? "Creando cuenta..." : "Crear cuenta"}
          </button>
          <p className="auth-switch">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
          </p>
        </form>
      </div>
    </>
  );
}